<template>
  <v-card
    flat
    width="100%"
    class="reset-password">
    <v-card-title
      class="font-weight-bold pa-0">
      <div class="mr-2">
        {{ email }}
      </div>
      <div>
        <v-icon
          v-if="exists"
          class="green--text">
          mdi-check-bold
        </v-icon>
        <span
          v-if="!exists"
          class="blue--text text-caption">
          (nuevo)
        </span>
      </div>
    </v-card-title>
    <send-code
      v-if="tab==='send_code'"
      :email="email"
      :exists="exists"
      @generated="generated"
      @canceled="canceled">
    </send-code>
    <verify-code
      v-if="tab==='verify_code'"
      :email="email"
      :exists="exists"
      @verified="verified"
      @canceled="canceled">
    </verify-code>
    <enter-password
      v-if="tab==='enter_password'"
      :email="email"
      :exists="exists"
      :verificationCode="verificationCode"
      @canceled="canceled">
    </enter-password>
  </v-card>
</template>

<script>

import SendCode from '@/components/Auth/SendCode.vue';
import VerifyCode from '@/components/Auth/VerifyCode.vue';
import EnterPassword from '@/components/Auth/EnterPassword.vue';

export default {
  name: 'RegisterUser',
  props: {
    email: {
      default: null,
    },
    exists: {
      default: false,
    },
    autoVerified: {
      default: false,
    },
  },
  data() {
    return {
      tab: 'send_code',
      verificationCode: null,
    };
  },
  async created() {
    if (this.autoVerified) {
      this.verified('');
    }
  },
  methods: {
    canceled() {
      if (this.autoVerified) {
        this.$emit('canceled');
      } else {
        switch (this.tab) {
          case 'enter_password':
            this.tab = 'verify_code';
            break;
          case 'verify_code':
            this.tab = 'send_code';
            break;
          default:
            this.$emit('canceled');
        }
      }
    },
    generated() {
      this.tab = 'verify_code';
    },
    verified(code) {
      this.verificationCode = code;
      this.tab = 'enter_password';
    },
  },
  components: {
    SendCode,
    VerifyCode,
    EnterPassword,
  },
};
</script>
